import Factory from '@leverege/factory';
import DefaultNodeDelegate from './DefaultNodeDelegate.js';
export default new Factory({
  strategy: Factory.LOOKUP,
  defaultObject: DefaultNodeDelegate
});